import { render } from "./myCollection.vue?vue&type=template&id=277dd5bc&scoped=true"
import script from "./myCollection.vue?vue&type=script&lang=js"
export * from "./myCollection.vue?vue&type=script&lang=js"

import "./myCollection.vue?vue&type=style&index=0&id=277dd5bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277dd5bc"]])

export default __exports__